<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">

    <h3 [i18nKey]="'studies.human.resources.wage.cost.detail'"></h3>
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th>
            </th>
            <th class="_numberColumn"[i18nKey]="'human.resources.employees.number'"></th>
            <th class="_numberColumn"[i18nKey]="'human.resources.employees.salary'"></th>
            <th class="_numberColumn"[i18nKey]="'human.resources.employees.wage.bill'"></th>
            <th colspan="2" class="_numberColumn"[i18nKey]="'studies.human.resources.employer.contribution'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="_totalColumn"[i18nKey]="'human.resources.cooking'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number"[i18nKey]="'common.studies.rate'"></td>
            <td class="_totalColumn _number"[i18nKey]="'common.studies.amount'"></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.head.chefs'"></td>
            <td class="_number">
                {{study.staffDecision.headChefNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.headChefSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.headChefNumber * study.staffDecision.headChefSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.cooks'"></td>
            <td class="_number">
                {{study.staffDecision.cookNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.cookSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.cookNumber * study.staffDecision.cookSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.commis.chefs'"></td>
            <td class="_number">
                {{study.staffDecision.commisChefNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.commisChefSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.commisChefNumber * study.staffDecision.commisChefSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.human.resources.cooks.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.cooksWageBill | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{study.humanResourcesParameters.employerContribution * 100  | number:'1.2'}}</td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.cooksWageBill * study.humanResourcesParameters.employerContribution | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'human.resources.service'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.maitres.d.hotel'"></td>
            <td class="_number">
                {{study.staffDecision.maitreDHotelNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.maitreDHotelSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.maitreDHotelNumber * study.staffDecision.maitreDHotelSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.head.waiters'"></td>
            <td class="_number">
                {{study.staffDecision.headWaiterNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.headWaiterSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.headWaiterNumber * study.staffDecision.headWaiterSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.waiters'"></td>
            <td class="_number">
                {{study.staffDecision.waiterNumber | number:'1.0'}}
            </td>
            <td class="_number">
                {{study.staffDecision.waiterSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_number">
                {{study.staffDecision.waiterNumber * study.staffDecision.waiterSalary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.human.resources.waiters.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.waitersWageBill | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_totalColumn _number">{{study.humanResourcesParameters.employerContribution * 100  | number:'1.2'}}</td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.waitersWageBill * study.humanResourcesParameters.employerContribution | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.total'"></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.totalWageBill | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
            </td>
            <td class="_totalColumn _number">{{study.humanResourcesParameters.employerContribution * 100 | number:'1.2'}}</td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.totalWageBill +
                study.humanResourcesResult.socialCharges | number:'1.2'}}
            </td>
        </tr>
        </tbody>
    </table>

    <h3 [i18nKey]="'studies.human.resources.firing'"></h3>

    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th></th>
            <th class="_numberColumn"[i18nKey]="'studies.human.resources.fired.number'"></th>
            <th class="_numberColumn"[i18nKey]="'human.resources.employees.salary'"></th>
            <th class="_numberColumn"[i18nKey]="'human.resources.severance.pay.in.months'"></th>
            <th class="_numberColumn"[i18nKey]="'common.studies.amount'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td class="_totalColumn"[i18nKey]="'human.resources.cooking'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.head.chefs'"></td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headChefsSeverancePayResult.fired | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headChefsSeverancePayResult.salary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.humanResourcesParameters.severancePayInMonths | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headChefsSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.cooks'"></td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.cooksSeverancePayResult.fired | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.cooksSeverancePayResult.salary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.humanResourcesParameters.severancePayInMonths | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.cooksSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.human.resources.cooks.total'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.severancePayResult.headChefsSeverancePayResult.severancePay + study.humanResourcesResult.severancePayResult.cooksSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'human.resources.service'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.maitres.d.hotel'"></td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.maitreDHotelsSeverancePayResult.fired | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.maitreDHotelsSeverancePayResult.salary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.humanResourcesParameters.severancePayInMonths | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.maitreDHotelsSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.head.waiters'"></td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headWaitersSeverancePayResult.fired | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headWaitersSeverancePayResult.salary | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></td>
            <td class="_number">{{study.humanResourcesParameters.severancePayInMonths | number:'1.0'}}</td>
            <td class="_number">{{study.humanResourcesResult.severancePayResult.headWaitersSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.human.resources.waiters.total'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.severancePayResult.maitreDHotelsSeverancePayResult.severancePay + study.humanResourcesResult.severancePayResult.headWaitersSeverancePayResult.severancePay | number:'1.2'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.studies.total'"></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="_totalColumn _number">{{study.humanResourcesResult.severancePayResult.totalSeverancePayResult | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
</div>
